import { render } from "./ElGrupoPage.vue?vue&type=template&id=088a34a4&scoped=true"
import script from "./ElGrupoPage.vue?vue&type=script&lang=js"
export * from "./ElGrupoPage.vue?vue&type=script&lang=js"

import "./ElGrupoPage.vue?vue&type=style&index=0&id=088a34a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088a34a4"]])

export default __exports__